<template>
  <!-- Title -->

  <div class="columns has-text-centered is-centered" v-if="loading">
    <loading
      font-size="20"
      line-fg-color="var(--primary-color)"
      size="massive"
      class="margin-100"
      text-fg-color="#2d3f51"
      message="الرجاء الإنتظار"
    />
  </div>
  <div v-else>


    <form action>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">تفاصيل طلب رقم {{ id }}</p>
        </header>
        <section class="modal-card-body">
          <div class="column">
            <table class="table is-striped is-small mb-40" v-if="notifications.length > 0">
              <thead></thead>
              <tbody>
                <tr v-for="notification in notifications" v-bind:key="notification.id">
                  <td>{{ notification.Title}}</td>
                  <td>{{ notification.Content}}</td>
                  <td>{{ notification.createdAt}}</td>
                </tr>
              </tbody>
            </table>
            <b  class="has-text-bold" v-else> لايوجد هناك اي تفاصيل </b>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-danger is-medium" type="button" @click="$parent.close()">اغلاق</button>
        </footer>
      </div>
    </form>
  </div>
</template>


<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";
import { async } from "q";
moment.locale("ar");

export default {
  name: "notify",
  props: ["id", "url"],

  data() {
    return {
      notifications: null,
      loading: false
    };
  },
  created() {
    this.loading = true;
    var user = JSON.parse(localStorage.getItem("user"));

    axios
      .get(this.url + this.id)
      .then(response => {
        console.log(response);
        this.notifications = response.data.results;
        this.loading = false;
      })
      .catch(error => {
        // this.$router.push('/');
      });
  }
};
</script>
